import { render, staticRenderFns } from "./LabelWithButtonEl.vue?vue&type=template&id=67fcab68&scoped=true&"
import script from "./LabelWithButtonEl.vue?vue&type=script&lang=ts&"
export * from "./LabelWithButtonEl.vue?vue&type=script&lang=ts&"
import style0 from "./LabelWithButtonEl.vue?vue&type=style&index=0&id=67fcab68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fcab68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
